import { useActiveUrlStore } from '@/store/activeUrlStore';
import { fetchPageSourceByUrl } from '@/services/scrapeFetchService';
import { useUrlSourcesStore } from '@/store/urlSourcesStore';
import { watchEffect } from 'vue';
import { parsePageSourceResponse } from '@/helpers/parsePageSourceResponse';

export default function useFetchHomepage() {
  // Initialize stores to access the current active URL and manage site URLs
  const activeUrlStore = useActiveUrlStore();
  const urlSourcesStore = useUrlSourcesStore();

  watchEffect(async () => {
    activeUrlStore.activeUrl;
    // Only proceed if there's a valid URL
    if (activeUrlStore.activeUrl) {
      const { data, statusCode } =
        await fetchPageSourceByUrl(
          activeUrlStore.activeUrl
        );
      if (statusCode == 200) {
        const parsedData = parsePageSourceResponse(data as string);
        const apiStatue = parsedData.status;
        const apiResponse = parsedData.data.httpResponse;
        if (apiStatue === 'success') {
          // Retrieve the HTTP response (page source) from the parsed data
          if (apiResponse) {
            urlSourcesStore.addHomepage(apiResponse);
          }
        }
      }
    }
  });
}
